import { useTranslation } from '~/lib/i18n'

const useTimeRemainingMessage = (endTimestamp: number) => {
  const { t } = useTranslation('common')

  const now = Date.now()

  const missingTimeInMinutes = Math.floor((endTimestamp - now) / 1000 / 60)
  const missingTimeInHours = Math.floor(missingTimeInMinutes / 60)
  const missingTimeInDays = Math.floor(missingTimeInHours / 24)

  if (missingTimeInDays >= 1) {
    const missingTimeInHoursMinusDays = missingTimeInHours - 24 * missingTimeInDays

    return `${missingTimeInDays} ${missingTimeInDays > 1 ? t('days') : t('day')} ${
      missingTimeInHoursMinusDays > 0
        ? `${t('and')} ${missingTimeInHoursMinusDays} ${missingTimeInHoursMinusDays > 1 ? t('hours') : t('hour')}`
        : ''
    }`
  }

  if (missingTimeInHours >= 1) {
    const missingTimeInMinutesMinusHours = missingTimeInMinutes - 60 * missingTimeInHours

    return `${missingTimeInHours} ${missingTimeInHours > 1 ? t('hours') : t('hour')} ${
      missingTimeInMinutesMinusHours > 0
        ? `${t('and')} ${missingTimeInMinutesMinusHours} ${
            missingTimeInMinutesMinusHours > 1 ? t('minutes') : t('minute')
          }`
        : ''
    }`
  }

  if (missingTimeInMinutes >= 1) {
    return `${missingTimeInMinutes} ${missingTimeInMinutes > 1 ? t('minutes') : t('minute')}`
  }

  return 'seconds'
}

export default useTimeRemainingMessage
